import React from "react";

import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
   return (
      <div id = "wrapper">
         <Header />
         <div id="page-wrapper">
            <div className = "container-fluid">
               { children }
            </div>
         </div>
         <Footer />
      </div>
   )
};

export default Layout;